// App configuration and i18n settings
export const AppConfig = {
  name: 'mygolfprofile',
  defaultLocale: 'en',
  locales: ['en', 'de', 'es', 'fr', 'it', 'nl', 'ru', 'sv', 'vi', 'ja', 'ko', 'zh'],
  languageLabels: {
    en: 'English', // English
    de: 'Deutsch', // German
    es: 'Español', // Spanish
    fr: 'Français', // French
    it: 'Italiano', // Italian
    nl: 'Nederlands', // Dutch
    ru: 'Русский', // Russian
    sv: 'Svenska', // Swedish
    vi: 'Tiếng Việt', // Vietnamese
    ja: '日本語', // Japanese
    ko: '한국어', // Korean
    zh: '中文（简体）', // Simplified Chinese
  },
} as const;

export type SupportedLocale = typeof AppConfig.locales[number];

// Helper function to check if a locale is supported
export const isSupportedLocale = (locale: string): locale is SupportedLocale => {
  return AppConfig.locales.includes(locale as SupportedLocale);
};
